<template>
  <a-button
    icon="apartment"
    size="small"
    type="link"
    @click="e => $emit('click', e)"
    style="color: #1890ff"
  >
    拓扑
  </a-button>
</template>

<script>
export default {
  name: 'TopologyButton'
}
</script>
